import {
  letters,
  lettersTransform,
  markViewBox,
  tagBody,
  tagFrame,
  tagHole,
  tagStringShort,
  tagStrokeWidth,
  tagTilt,
} from '@core/brand/mark';

/**
 * The AttireRent mark on its tile: the white swing tag with AR, on the theme's colour.
 *
 * <p>
 * The tile is `bg-primary` by default, so the mark follows the person's theme like every other
 * accent; the letters and the hole take the same colour (`currentColor` with `text-primary`), which
 * reads as cut out of the tag. A caller with a fixed colour (the sign-in page) passes `tone`. The
 * shapes come from `@core/brand/mark`, the same ones the app icon files are drawn from.
 * </p>
 */
export function BrandMark({
  size = 28,
  tone,
  className = '',
}: {
  size?: number;
  /** A fixed tile colour; the theme's when absent. */
  tone?: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={`grid shrink-0 place-items-center rounded-md ${tone ? '' : 'bg-primary text-primary'} ${className}`}
      style={{
        width: size,
        height: size,
        ...(tone ? { background: tone, color: tone } : {}),
      }}
    >
      <svg viewBox={markViewBox} width={size * 0.62} height={size * 0.9}>
        <g transform={tagTilt}>
          <path
            d={tagStringShort}
            fill="none"
            stroke="#ffffff"
            strokeWidth={2.2}
            strokeLinecap="round"
          />
          <path
            d={tagBody}
            fill="#ffffff"
            stroke="#ffffff"
            strokeWidth={tagStrokeWidth}
            strokeLinejoin="round"
          />
          <path
            d={tagFrame}
            fill="none"
            stroke="currentColor"
            strokeOpacity={0.28}
            strokeWidth={1.1}
          />
          <circle cx={tagHole.cx} cy={tagHole.cy} r={tagHole.r} fill="currentColor" />
          <path d={letters} transform={lettersTransform} fill="currentColor" />
        </g>
      </svg>
    </span>
  );
}
